module.exports = __webpack_public_path__ + "img/icon_tweed_20_active.43dcf6b3.png";